module.exports = __webpack_public_path__ + "img/r_angelov.466b6fce.jpg";